import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/**
 * Custom hook for platform detection
 * Returns platform-specific information and utilities
 */
export const usePlatform = () => {
  const theme = useTheme();
  
  // Mobile detection (below md breakpoint)
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  
  // Desktop detection (md and above)
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  
  // Tablet detection (between sm and md)
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  
  // Large desktop detection (lg and above)
  const isLargeDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  
  // Extra large desktop detection (xl and above)
  const isExtraLargeDesktop = useMediaQuery(theme.breakpoints.up('xl'));

  return {
    // Platform detection
    isMobile,
    isDesktop,
    isTablet,
    isLargeDesktop,
    isExtraLargeDesktop,
    
    // Platform-specific utilities
    platform: isMobile ? 'mobile' : 'desktop',
    
    // Responsive breakpoints
    breakpoints: {
      xs: useMediaQuery(theme.breakpoints.up('xs')),
      sm: useMediaQuery(theme.breakpoints.up('sm')),
      md: useMediaQuery(theme.breakpoints.up('md')),
      lg: useMediaQuery(theme.breakpoints.up('lg')),
      xl: useMediaQuery(theme.breakpoints.up('xl')),
    },
    
    // Platform-specific features
    features: {
      touch: isMobile || isTablet,
      keyboard: isDesktop,
      mouse: isDesktop,
      largeScreen: isLargeDesktop || isExtraLargeDesktop,
    }
  };
};
